/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DoubleRangeModel model module.
 * @module model/DoubleRangeModel
 * @version v1.0.0
 */
class DoubleRangeModel {
    /**
     * Constructs a new <code>DoubleRangeModel</code>.
     * @alias module:model/DoubleRangeModel
     */
    constructor() { 
        
        DoubleRangeModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DoubleRangeModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DoubleRangeModel} obj Optional instance to populate.
     * @return {module:model/DoubleRangeModel} The populated <code>DoubleRangeModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DoubleRangeModel();

            if (data.hasOwnProperty('max')) {
                obj['max'] = ApiClient.convertToType(data['max'], 'Number');
            }
            if (data.hasOwnProperty('min')) {
                obj['min'] = ApiClient.convertToType(data['min'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} max
 */
DoubleRangeModel.prototype['max'] = undefined;

/**
 * @member {Number} min
 */
DoubleRangeModel.prototype['min'] = undefined;






export default DoubleRangeModel;

